<style lang="scss" src='./SensorOverview.scss' scoped></style>
<template src="./SensorOverview.html"></template>

<script>
import Vue from 'vue';
import GwRing from '@/components/gwRing/GwRing.vue';
import { mapState, mapMutations } from 'vuex';
import { GetSensorRingGraph, CleanUpSensor, UpdateGPS, getDailyTemps } from '@/api/api';
import GwPassword from '@/components/gwPassword/GwPassword.vue';

export default {
  name: 'SensorOverview',
  components: {
    GwRing,
    GwPassword,
  },
  props: {
    sensor: {
      required: true,
    },
  },
  data() {
    return ({
      iconRssi: null,
      ringsData: {},
      password: null,
      loading: {
        ringsGraph: false,
        cleaningSensor: false,
      },
      uom: 'DEPTH',
      invalidText: this.$t('general.invalid'),
      dailyTemps: {},
    });
  },
  computed: {
    ...mapState(['course']), 
    ...mapState('SensorList', {
      rssiRanges: (state) => state.rssiRanges,
    }),
    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
    showNoDataMessage(){
      let objValid = Object.keys(this.ringsData).length;
      if (!objValid) {
        return true
      }
      return false
    },
    validCoordinates() {
      if(this.sensor && this.sensor.latitude){
        if(this.G_validateLatLong(this.sensor.latitude, this.sensor.longitude)){
          return true;
        }
      }
      return false;
    },
  },
  watch: {
  },

  methods: {
    getSIMValue(sim) {
      const simValue = this.consts.SIM.find((item) => item.key == sim);
      if (simValue) {
        return simValue.value;
      }
      return '-';
    },

    getDepth(value){
      if (this.course.measurement_system == "METRIC") {
          return Math.round(value * 2.54)
      }
      return value
    },

    async loadSensorRingGraph() {
      this.loading.ringsGraph = true;
      const ringsDataReponse = await GetSensorRingGraph(this.sensor.sensor_id);
      this.ringsData = ringsDataReponse ? this.G_getSensorRingsData(ringsDataReponse.data) : {};
      this.loading.ringsGraph = false;
    },

    async loadDailyTemps() {
      this.loading.dailyTemps = true;
      const dailyResponse = await getDailyTemps(this.sensor.sensor_id);
      this.dailyTemps = {
        min_dielectric: this.G_getMeasurement({
          val: dailyResponse[0].min_dielectric,
          uom: this.consts.UOM.DIELECTRIC,
          addUnit: true,
          invertUOM: false,
        }),
        max_dielectric: this.G_getMeasurement({
          val: dailyResponse[0].max_dielectric,
          uom: this.consts.UOM.DIELECTRIC,
          addUnit: true,
          invertUOM: false,
        }),
        min_temp: this.G_getMeasurement({
          val: dailyResponse[0].min_temp,
          uom: this.consts.UOM.TEMP,
          addUnit: true,
          invertUOM: false,
        }),
        max_temp: this.G_getMeasurement({
          val: dailyResponse[0].max_temp,
          uom: this.consts.UOM.TEMP,
          addUnit: true,
          invertUOM: false,
        }),
        min_salinity_ms: this.G_getMeasurement({
          val: dailyResponse[0].min_salinity,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        max_salinity_ms: this.G_getMeasurement({
          val: dailyResponse[0].max_salinity,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        min_salinity: this.G_getMeasurement({
          val: dailyResponse[0].min_salinity / 100,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        max_salinity: this.G_getMeasurement({
          val: dailyResponse[0].max_salinity / 100,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        min_moisture: this.G_getMeasurement({
          val: dailyResponse[0].min_moisture,
          uom: this.consts.UOM.MOISTURE,
          addUnit: true,
          invertUOM: false,
        }),
        max_moisture: this.G_getMeasurement({
          val: dailyResponse[0].max_moisture,
          uom: this.consts.UOM.MOISTURE,
          addUnit: true,
          invertUOM: false,
        }),
        min_et: this.G_getMeasurement({
          val: dailyResponse[0].min_et,
          uom: this.consts.UOM.ET_RATE,
          addUnit: true,
          invertUOM: false,
        }),
        max_et: this.G_getMeasurement({
          val: dailyResponse[0].max_et,
          uom: this.consts.UOM.ET_RATE,
          addUnit: true,
          invertUOM: false,
        }),
      };
      this.loading.dailyTemps = false;

      console.log('Daily Temps', this.dailyTemps);
    },

    async updateGPS() {
      let data = {
          attributes: {},
          command: 6,
          sensor_id: this.sensor.sensor_id
      }

      await UpdateGPS(data).then(resp => {
        Vue.notify({ type: 'success', text: this.$t('sensorCommand.success') });
      }).catch((err) => {
        Vue.notify({ type: 'error', text: this.$t('sensorCommand.error') });
      });;
    },

    async loadData() {
      this.iconRssi = require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(this.sensor, this.rssiRanges)}`);
      this.loadSensorRingGraph();
      this.loadDailyTemps();
    },

    async cleanUpSensor(){
      if (this.password) {
        this.loading.cleaningSensor = true;
          await CleanUpSensor(this.sensor.sensor_id, this.password).then( sensorCleaned => {
            this.$bvModal.hide('md-clean-up-sensor');
            this.updateSensor(sensorCleaned);
            this.$router.go(-1);
          }).finally(() => {
            this.loading.cleaningSensor = false;
          });
        
      } else {
        this.$notify({ ignoreDuplicates: true, type: 'warn', text: this.$t('login.enterYourPassword'), });
      }
    },

    ...mapMutations('SensorList', ['updateSensor']),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.loadData();
  },
};
</script>
